import type { InjectionKey } from 'vue'

export const NavbarComponentSymbol = Symbol('NavbarComponent') as InjectionKey<{
    isMobileMenuOpen: Ref<boolean>
}>
